/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const getTeamTimelineParamsDisplayTimeZoneMax = 100;

export const getTeamTimelineParamsReferenceDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const getTeamTimelineParamsRangeDefault = `two-weeks`;
export const getTeamTimelineParamsStateDefault = `active`;
export const GetTeamTimelineParams = zod.object({
  displayTimeZone: zod.string().min(1).max(getTeamTimelineParamsDisplayTimeZoneMax),
  referenceDate: zod.iso.date().regex(getTeamTimelineParamsReferenceDateRegExp),
  range: zod
    .enum(['one-day', 'one-week', 'two-weeks', 'one-month'])
    .default(getTeamTimelineParamsRangeDefault),
  state: zod.enum(['active', 'archived']).default(getTeamTimelineParamsStateDefault),
});

export type GetTeamTimelineParams = zod.input<typeof GetTeamTimelineParams>;
export type GetTeamTimelineParamsOutput = zod.output<typeof GetTeamTimelineParams>;
